import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isDataLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';

const mapFilterData = (data: IDataLineSearchForm): IDataLineSearchPost | {} => {
  if (isDataLineSearchFormEmpty(data) || data == undefined) { return {} };

  if(data.deleted === "false"){
    data.removalDateTo = "";
    data.removalDateFrom = "";
  }

  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllLines = async ( {data} : {data: IDataLineSearchForm}): Promise<IGetLines> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  const response =  await axiosDefaultApi.post(`api/Search/Search/DataLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetLines;
};

type QueryFnType = typeof getAllLines;

type UseGetAllLinesOptions = {
  data: IDataLineSearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllLines = ({ data, config }: UseGetAllLinesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllLines'],
    queryFn: () => getAllLines({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των Γραμμών Data.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};